// Importing all Controllers
import './MainCtrl';
import './EnterDataCtrl';
import './CustomerCtrl'
import './ManagerCtrl'
import './ScanStationCtrl'
import './AuthController'
import './ComplianceCtrl'
